import React, { useState } from 'react'
import { LeftOutlined } from "@ant-design/icons";
import { Text } from "../../formitems/Index";
import { storage } from "../../../Firebase/firebase";
const EditGround = ({ name, groundFormAdd, catagories, currentFormData, closeForm, handleFormFields }) => {
    const [image, setImage] = useState();
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState("");
    const [url, setUrl] = useState("");
    const [images, setImages] = useState();
    const [progresss, setProgresss] = useState(0);
    const [errors, setErrors] = useState("");
    const [urls, setUrls] = useState("");
    const types = ["application/pdf"];
    if (catagories === 'Ground') {
        var Grounds = `studymat_Ground_${currentFormData?.groundformid}`
    }
    const handChange = e => {
        const file = e.target.files[0];
        if (file) {
            const fileType = file["type"];
            if (types.includes(fileType)) {
                setError("");
                setImage(file);
                setUrl("")
            } else {
                setError("Please select an image to upload");
            }
        }
    };
    const handleUpdate = () => {
        if (image) {
            const uploadTask = storage.ref(`${name}/study material/${Grounds}`).put(image);
            uploadTask.on(
                "state_changed",
                snapshot => {
                    const progress = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );
                    setProgress(progress);
                },
                error => {
                    setError(error);
                },
                () => {
                    storage
                        .ref(`${name}/study material`)
                        .child(`${Grounds}`)
                        .getDownloadURL()
                        .then(url => {
                            setUrl(url);
                            setProgress(0);
                        });
                }
            );
        } else {
            setError("Error please choose an image to upload");
        }
    };

    if (catagories === 'Ground') {
        var Ground = `Presentation_Ground_${currentFormData?.groundformid}`
    }
    const handChanges = e => {
        const file = e.target.files[0];
        if (file) {
            const fileType = file["type"];
            if (types.includes(fileType)) {
                setErrors("");
                setImages(file);
                setUrls("")
            } else {
                setError("Please select an image to upload");
            }
        }
    };
    const handleUpdates = () => {
        if (images) {
            const uploadTask = storage.ref(`${name}/study material/${Ground}`).put(images);
            uploadTask.on(
                "state_changed",
                snapshot => {
                    const progresss = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );
                    setProgresss(progresss);
                },
                error => {
                    setErrors(error);
                },
                () => {
                    storage
                        .ref(`${name}/study material`)
                        .child(`${Ground}`)
                        .getDownloadURL()
                        .then(url => {
                            setUrls(url);
                            setProgresss(0);
                        });
                }
            );
        } else {
            setErrors("Error please choose an image to upload");
        }
    };
    const emptyState = () => {
        setImage(null)
        setProgress(0)
        setError('')
        setUrl('')
        setImages(null)
        setProgresss(0)
        setErrors('')
        setUrls('')
        closeForm()
    }
    console.log(urls)
    console.log(url)
    return (
        <div>
            <div className="category-title">
                <span className="client-back" onClick={() => closeForm()}>
                    {<LeftOutlined />} Form
            </span>
            Edit {catagories === 'Ground'? "Ground" : null} Form
          </div>
            <div className="toggle-form-container">
                <div className="input-box-container">
                    <Text title="Q. Code" disabled value={currentFormData?.groundformname} onChange={(e) => handleFormFields(e.target.value, 'groundformname')} />
                    <div>
                        <h4>Edit Study Material Document</h4>
                        <br />
                        <input type="file" style={{ backgroundColor: 'beige', borderRadius: '25px' }} onChange={handChange} />
                        <br />
                        <h5><a href={!url ? currentFormData.studymat : url} target="_blank">{currentFormData.studymat === null ?<span style={{ color: 'red' }}> "Study Material not yet uploaded !!!" </span>: 'Study Material View / Download'}</a> </h5>
                        <br />
                        <br />
                        <h4>Edit Presentation Document</h4>
                        <br />
                        <input type="file" style={{ backgroundColor: 'beige', borderRadius: '25px' }} onChange={handChanges} />
                        <br />
                        <h5><a href={!urls ? currentFormData.presentation : urls} target="_blank">{currentFormData.presentation === null ? <span style={{ color: 'red' }}>"Document not yet uploaded !!!" </span> : 'Presentation View / Download'}</a> </h5>
                        {!url || !urls ? <button className="cancel-button" onClick={() => {
                            handleUpdate()
                            handleUpdates()
                        }} >Save</button> : null}
                    </div>
                </div>
                {url && urls ? (
                    <div>
                        <button className="submit-button" onClick={() => {
                            groundFormAdd({
                                variables: { studyMaterial: url, presentation: urls, id: currentFormData?.simformid }
                            })
                            emptyState()
                        }}>Update</button>
                        <button onClick={() => emptyState()} className="cancel-button">
                            Cancel
                    </button>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default EditGround
